import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { motion } from "framer-motion";
import { Buildings, ArrowRight } from "@phosphor-icons/react";

const HERO_IMG = "https://images.unsplash.com/photo-1758901810612-55ba2c317a53?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBhYnN0cmFjdCUyMGFyY2hpdGVjdHVyZSUyMGRhcmslMjBsdXh1cnl8ZW58MHx8fHwxNzc4NDc3MDE1fDA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const navigate = useNavigate();
  const { login, error } = useAuth();
  const [email, setEmail] = useState("hier@jeemail.nl");
  const [password, setPassword] = useState("Hierjewachtwoorddiejehebtgekregen");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) navigate("/", { replace: true });
  };

  return (
    <div className="min-h-screen w-full grid lg:grid-cols-2 bg-background">
      {/* Left — form */}
      <div className="flex items-center justify-center p-8 lg:p-16">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="w-full max-w-md"
        >
          <div className="flex items-center gap-2.5 mb-12">
            <div className="w-9 h-9 rounded-md bg-primary/15 hairline-border flex items-center justify-center">
              <Buildings size={20} weight="duotone" className="text-primary" />
            </div>
            <div className="leading-tight">
              <div className="font-display text-xl tracking-tight">Zippe </div>
              <div className="overline -mt-0.5">International CRM</div>
            </div>
          </div>

          <h1 className="font-display text-4xl lg:text-5xl tracking-tight leading-none mb-3">
            Welcome <span className="gold-text">back.</span>
          </h1>
          <p className="text-muted-foreground text-sm mb-10 leading-relaxed">
            Sign in to your workspace. Your pipeline, customers and AI are waiting.
          </p>

          <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
            <div className="space-y-2">
              <Label htmlFor="email" className="overline">Email</Label>
              <Input
                id="email" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email"
                className="h-11"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="overline">Password</Label>
              <Input
                id="password" type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                className="h-11"
              />
            </div>

            {error && (
              <div className="text-sm text-destructive bg-destructive/10 border border-destructive/30 px-3 py-2 rounded-md" data-testid="login-error">
                {error}
              </div>
            )}

            <Button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="w-full h-11 rounded-full font-medium tracking-wide bg-primary hover:bg-primary/90 text-primary-foreground transition-all"
            >
              {loading ? "Signing in…" : (<>Sign in <ArrowRight size={14} weight="bold" className="ml-2" /></>)}
            </Button>
          </form>

          <div className="mt-10 pt-6 border-t border-border/60">
            <div className="overline mb-2"></div>
            <div className="text-xs text-muted-foreground space-y-1">
              <div>admin inlog volgt</div>
              <div>gebruikers inlog volgt</div>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Right — visual */}
      <div className="hidden lg:block relative overflow-hidden bg-black">
        <img src={HERO_IMG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-80" />
        <div className="absolute inset-0 bg-gradient-to-br from-black/80 via-black/40 to-transparent" />
        <div className="absolute inset-0 grain"></div>
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <div className="overline text-white/70 mb-3">— Designed for operators</div>
          <h2 className="font-display text-3xl xl:text-4xl tracking-tight leading-tight mb-4">
            Old money meets future tech.
          </h2>
          <p className="text-white/70 text-sm max-w-md leading-relaxed">
            A single, precise control room for sales, manufacturing, investors and circular textile partners.
          </p>
        </div>
      </div>
    </div>
  );
}
